export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/mezzopiano-icon.svg?30179c12e1b63d18f502f45f35ecef1d";